import { useCallback, useEffect, useState } from "react";

import { useBoolean } from "react-use";

export const useVocalGuideState = (
	instrumentalVideoElement: HTMLVideoElement | null,
	vocalGuideVideoElement: HTMLVideoElement | null,
) => {
	const [activeVideoElement, setActiveVideoElement] =
		useState<HTMLVideoElement | null>(instrumentalVideoElement);
	const [isVocalGuideActivated, setIsVocalGuideActivated] = useBoolean(false);

	const getVideoElementsByStatus = useCallback(() => {
		return isVocalGuideActivated
			? {
					active: vocalGuideVideoElement ?? instrumentalVideoElement,
					inactive: instrumentalVideoElement,
				}
			: {
					active: instrumentalVideoElement,
					inactive: vocalGuideVideoElement ?? instrumentalVideoElement,
				};
	}, [instrumentalVideoElement, isVocalGuideActivated, vocalGuideVideoElement]);

	useEffect(() => {
		const videoElementsByStatus = getVideoElementsByStatus();
		setActiveVideoElement(videoElementsByStatus.active);
	}, [getVideoElementsByStatus, setActiveVideoElement, isVocalGuideActivated]);

	useEffect(() => {
		const { active: activeElement, inactive: inactiveElement } =
			getVideoElementsByStatus();

		if (!activeElement || !inactiveElement) {
			return;
		}

		// Active element is set to play after ref changement in B2bPlayerArea.tsx
		inactiveElement.pause();
		activeElement.pause();
		activeElement.currentTime = inactiveElement.currentTime;
	}, [getVideoElementsByStatus]);

	const activateVocalGuide = useCallback(() => {
		setIsVocalGuideActivated(true);
	}, [setIsVocalGuideActivated]);

	const deactivateVocalGuide = useCallback(() => {
		setIsVocalGuideActivated(false);
	}, [setIsVocalGuideActivated]);

	return {
		isVocalGuideActivated,
		activeVideoElement,
		activateVocalGuide,
		deactivateVocalGuide,
	};
};
